module.exports = __webpack_public_path__ + "static/media/settings_icon.031bc451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/settings_icon.svg
// module id = 470
// module chunks = 0